<template>
  <div class="view-leads">
    <div class="vx-row header mb-6">
      <div class="vx-col flex sm: w-full md:w-1/2">
        <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
          @click="goBack()"></vs-button>
        <div class="justify-right">
          <h2 class="pl-2">{{ $t("labels.project_view") }}</h2>
        </div>
      </div>
      <div class="history vx-col sm: w-full md:w-1/2 sm: mt-4 md:mt-0 justify-right">
        <vs-button v-if="isShowReport" color="danger" type="filled" icon-pack="feather" icon="icon-file-text"
          @click="showReportPopup" class="float-right mr-5">{{ $t("labels.report") }}</vs-button>
        <vs-button v-if="project && project.id && !isUserType('CN')" id="bt_dwl_insp_zip" color="warning" type="filled"
          icon-pack="feather" icon="icon-download" @click="downloadInspectionImgV3()" class="float-right mr-5">{{
            $t("labels.inspection_image") }}</vs-button>
      </div>
    </div>

    <div class="view-projects">
      <view-project :project="project"></view-project>
      <div class="vx-row w-full mx-0" v-if="!isUserType('CL')">
        <div v-for="(
specific_consultant_services, index
          ) in consultant_services_array" :key="index" :class="[
            consultant_services_array.length % 2 === 1 &&
              consultant_services_array.length - 1 === index
              ? 'md:w-full consultant-view'
              : 'consultant_details',
            'vx-col w-full md:w-1/2 p-0 ',
          ]">
          <vx-card class="project-details mt-4 mb-6" :title="specific_consultant_services.consultant_name">
            <div class="vx-col sm:w-full mt-4">
              <!-- Work Instruction -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.work_instructions") }}:</label>
                </div>
                <div class="vx-col sm:w-1/2 md:w-2/3 label-center">
                  <span>{{
                    specific_consultant_services.work_instructions_text
                  }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.work_instruction_attachment") }}:</label>
                </div>
                <div class="vx-col sm:w-1/2 md:w-2/3 label-center">
                  <a target="_blank" :href="specific_consultant_services.work_instructions_attachment
                    ">
                    <span v-if="
                      specific_consultant_services.work_instructions_attachment
                    ">
                      {{
                        getFileName(
                          specific_consultant_services.work_instructions_attachment
                        )
                      }}
                    </span>
                    <span v-else> - </span>
                  </a>
                </div>
              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm: w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.services") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2 md:w-2/3 label-center" v-if="specific_consultant_services.service_ids">
                  <span :key="index" v-for="(
service_arr, index
                    ) in specific_consultant_services.service_ids.join(' , ')">{{ service_arr }}</span>
                </div>
              </div>
            </div>
            <div class="status">
              <vs-chip color="primary" class="status-name">{{
                specific_consultant_services.status
              }}</vs-chip>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <vs-popup class="holamundo" :title="$t('labels.review_report')" :active.sync="popupActiveReview">
      <vs-table :data="reports" class="permission">
        <template slot="thead">
          <vs-th class="col-md-9">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">
              {{ tr.name }}
            </vs-td>
            <vs-td :data="tr">
              <vs-button v-if="!isPdf(tr)" type="flat" :title="$t('labels.view')" size="large" icon-pack="feather"
                icon="icon-download" color="dark" @click="openReviewReport(tr.report_url)"></vs-button>
              <vs-button v-else type="flat" :title="$t('labels.view')" size="large" icon-pack="feather" icon="icon-eye"
                color="dark" @click="openReviewReport(tr.report_url)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <project-questions v-if="!isUserType('CL')" :folderSections="folderSections"></project-questions>
    <div v-if="isUserType('CL') && folderSections.length" id="inspection-image">
      <InspectionViewImage :project="project" page="viewProject" ref="inspectionImg" :sectionInfo="folderSections"
        :vesselSubTypeInfo="vesselSubTypeInfo"></InspectionViewImage>
    </div>
  </div>
</template>
<script>
import ViewProject from "@/layouts/components/projects/view-project.vue";
import ProjectQuestions from "@/layouts/components/projects/project-questions.vue";
import InspectionViewImage from "@/components/inspection-view-image";
import { runTutorial } from '@/tutorial/guide.js';

import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      services: "",
      service: [],
      services_drop: [],
      consultant: [],
      consultants_drop: [],
      consultants: "",
      consultant_services_array: [],
      service_ids: "",
      id: this.$route.params.id,
      model: "project",
      project: {},
      currentx: 1, // current page
      question_length: 0, // length of all questions
      perPage: 10, // perPage
      start: 0,
      end: 10,
      folderSections: [],
      vesselSubTypeInfo: null,
      reports: [],
      popupActiveReview: false,
    };
  },
  components: {
    ViewProject,
    ProjectQuestions,
    InspectionViewImage,
  },
  computed: {
    ...mapGetters(["isClientRole"]),
    isShowReport() {
      return (
        this.project &&
        this.project.report_url &&
        (this.isClientRole ? ["SC", "CL"].includes(this.project.status) : true)
      );
    },
  },
  async mounted() {
    await this.getProject();
    await this.getProjectFolderSubFolder();
    this.$nextTick(() => {
      // …and one more animation frame so the sidebar is ready too
      console.log("Running intro.js tutorial...");
      requestAnimationFrame(() => {
        runTutorial([
          {
            element: '#bt_dwl_insp_zip',
            intro: 'You can download your inspection image here.',
            key: 'download-images',
          },
          {
            element: '#inspection-image',
            intro: 'You can click on markers to view your inspection image here.',
            key: 'view-inspection-images',
          },
        ]);
      });
    });
  },
  methods: {
    getFileName(url) {
      if (Array.isArray(url) && typeof url[0] === "string") {
        const actualUrl = url[0];
        const filename = actualUrl.substring(actualUrl.lastIndexOf("/") + 1);
        return decodeURIComponent(filename);
      }
      return "";
    },
    // API Integration for getData
    async getProject() {
      this.$vs.loading();
      let url = this.isUserType("CL") ? "/projects/get/min/" : "/projects/get/";
      let response = await this.getHTTPGetResponse(url + this.$route.params.id);

      if (response) {
        let data = response.data;
        let project = data.project;
        this.project = data.project;
        this.project_name = project.name;
        this.date = project.date;
        this.vessel_name = project.vessel ? project.vessel.name : "";
        this.reviewer_name = project.reviewer ? project.reviewer.name : "";
        this.remarks = project.remarks;
        this.status = project.status_name;
        let services = project.services;
        this.port_name = project.port;
        this.vesselSubTypeInfo = {
          ...project.vessel_sub_type,
          ship_image_url: project.ship_url,
        };
        services.forEach((element) => {
          this.service.push(element.name);
        });
        this.services = this.service.join(" , ");
        let consultants = project.consultants;
        consultants.forEach((element) => {
          this.consultant.push(element.name);
        });
        this.consultants = this.consultant.join(" , ");

        // Map
        setTimeout(() => {
          let consultant_services_data = [];
          consultants.forEach((consultant) => {
            var services = consultant.project_consultant.services;
            let ser_id = [];
            services = services.forEach((serve) => {
              let qlength = serve.project_consultant_service.questions.length;
              ser_id.push(serve.name + ` (${qlength} questions)`);
            });
            consultant_services_data.push({
              consultant_id: consultant.id,
              consultant_name: consultant.name,
              services: this.service,
              work_instructions_text:
                consultant.project_consultant.work_instructions_text,
              work_instructions_attachment:
                consultant.project_consultant.work_instructions_attachment,
              status: consultant.project_consultant.status_name,
              service_ids: ser_id,
            });
          });
          this.consultant_services_array = consultant_services_data;
        }, 100);

        this.$vs.loading.close();
      }
    },
    goBack() {
      history.back();
    },
    async showReportPopup() {
      const project_id = this.$route.params.id;
      const res = await this.getHTTPPostResponse(
        `projects/${project_id}/report/list`
      );
      if (res && res.status == 200) {
        if (!res.data.projectReports.length) {
          this.$vs.notify({
            title: "Error.",
            text: "No Reports Found",
            color: "danger",
            position: "top-right",
          });
          return;
        }
        this.reports = res.data.projectReports;
        this.popupActiveReview = true;
      }
    },
    openReviewReport(url) {
      window.open(url, "_blank");
    },
    async downloadInspectionImg() {
      const project_id = this.project.id;
      const res = await this.getHTTPGetResponse(
        `/projects/${project_id}/inspection/image/zip`,
        "#bt_dwl_insp_zip",
        true
      );
      if (res.status == 200 && res.data.zip_url) {
        const fileName = `${this.project.name}.zip`;
        this.downloadZipApp(res.data.zip_url, fileName);
      }
    },
    async downloadInspectionImgV3() {
      const project_id = this.project.id;
      const res = await this.getHTTPGetResponse(
        `/projects/${project_id}/inspection/image/zip/v3`,
        "#bt_dwl_insp_zip",
        true
      );
      if (res.status == 200 && res.data.zip_url) {
        const fileName = `${this.project.name}.zip`;
        this.downloadZipApp(res.data.zip_url, fileName);
      }
    },
    downloadInspectionImgBack() {
      // this.$vs.loading();
      this.$vs.notify({
        title: "Downloading...",
        text: "Please do not refresh",
        color: "warning",
        icon: "download",
        time: 5000,
      });
      const project_id = this.project.id;
      const project_name = _.snakeCase(this.project.name);
      this.axios
        .get(`/projects/${project_id}/inspection/image/zip`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          var formatted_date = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "");
          let zipName = project_name + "_" + formatted_date;
          this.downloadZipFile(data, zipName);
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    async getProjectFolderSubFolder() {
      const projectId = this.$route.params.id;
      const response = await this.getHTTPGetResponse(
        `/projects/${projectId}/folder/subfolder/get-folders`
      );
      if (response && response.data) {
        this.folderSections = response.data.folders.map((v) => {
          return {
            ...v,
            imageUrl: v.ga_plan_image || null,
            location: v.location ? JSON.parse(v.location) : null,
            subFolders: v.subFolders.map((subFolder) => ({
              ...subFolder,
              location: subFolder.location
                ? JSON.parse(subFolder.location)
                : null,
            })),
          };
        });
      }
    },
    isPdf(data) {
      const regex = /\.pdf$/;
      const url = data.report_url;
      return regex.test(url);
    },
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}

.question-feather {
  vertical-align: middle;
}

.label-center {
  align-self: center !important;
}

a,
a:hover {
  color: #626262;
  text-decoration: none;
}
</style>
